/// <amd-module name="Dashboards/DashboardView/src/utilities/PostTTILoadedLegacyDependencies" />
import { ILegacyPlatformService } from "VSS/Legacy/Legacy";
import { IVssPageContext } from "VSS/Platform/Context";
import { IVssContributionService } from "VSS/Platform/Contribution";

/// <amd-module name="Dashboards/DashboardView/src/utilities/PostTTILoadedDependencies" />
/**
 * Contributions to optimistically load after TTI to provide users
 * a better first interaction experience with features of a dashboard
 * by virtue of them not having to wait for these contributions to load.
 */
const contributionsToLoadAfterTTI: string[] = [];

/**
 * Code modules to optimistically load after TTI to provide users
 * a better first interaction experience with features of a dashboard
 * by virtue of them not having to wait for these contributions to load.
 */
const modulesToLoadAfterTTI: string[] = [
    // DashboardSettingsManager
    "Dashboards/Components/Shared/ManageDashboardDialog/ManageDashboardDialogShim"
];

export function loadPostTTILegacyDependencies(pageContext: IVssPageContext): void {
    if (contributionsToLoadAfterTTI.length > 0) {
        const contributionService: IVssContributionService = pageContext.getService("IVssContributionService");
        contributionService.getContributionsAsync(contributionsToLoadAfterTTI);
    }

    // Just retrieving the ILegacyPlatformService loads some legacy scripts,
    // so we check if we wanted to delay load any scripts before retrieving the service.
    if (modulesToLoadAfterTTI.length > 0) {
        const legacyService: ILegacyPlatformService = pageContext.getService("ILegacyPlatformService");
        legacyService.requireModules(modulesToLoadAfterTTI);
    }
}
